(function () {
  var storageKey = 'weilai_recently_viewed_v1';

  function renderSection(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var grid = section.querySelector('[data-recently-viewed-grid]');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 5;
    if (window.matchMedia('(max-width: 767px)').matches) {
      limit = parseInt(section.getAttribute('data-mobile-limit'), 10) || 4;
    }
    var currency = section.getAttribute('data-currency') || 'GBP';

    function formatPrice(value) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: currency
        }).format(value / 100);
      } catch (error) {
        return (value / 100).toFixed(2) + ' ' + currency;
      }
    }

    function renderProduct(product, url) {
      if (!product || !product.available || !product.featured_image) return;
      var card = document.createElement('a');
      card.className = 'weilai-recently-viewed__card';
      card.href = url;

      var imageWrap = document.createElement('div');
      imageWrap.className = 'weilai-recently-viewed__image-wrap';
      var image = document.createElement('img');
      image.className = 'weilai-recently-viewed__image';
      image.src = product.featured_image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      imageWrap.appendChild(image);
      card.appendChild(imageWrap);

      var title = document.createElement('p');
      title.className = 'weilai-recently-viewed__title';
      title.textContent = product.title || '';
      card.appendChild(title);

      var price = document.createElement('p');
      price.className = 'weilai-recently-viewed__price';
      price.textContent = formatPrice(product.price);
      card.appendChild(price);
      grid.appendChild(card);
    }

    function isSameStoreProduct(entry) {
      if (!entry || !entry.handle || !entry.url) return false;
      try {
        var url = new URL(entry.url, window.location.origin);
        return url.origin === window.location.origin && url.pathname.indexOf('/products/') !== -1;
      } catch (error) {
        return false;
      }
    }

    try {
      var viewed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(viewed) || !viewed.length) return;
      var entries = viewed.filter(isSameStoreProduct).slice(0, limit);
      if (!entries.length) return;

      Promise.all(entries.map(function (entry) {
        return fetch(entry.url.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (product) { return { product: product, url: entry.url }; })
          .catch(function () { return null; });
      })).then(function (results) {
        results.forEach(function (result) {
          if (result) renderProduct(result.product, result.url);
        });
        if (grid.children.length) section.hidden = false;
      });
    } catch (error) {
      // An empty or unavailable browser store keeps this section hidden.
    }
  }

  function initializeSections(root) {
    if (!root) return;
    if (root.matches && root.matches('.weilai-recently-viewed')) renderSection(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('.weilai-recently-viewed').forEach(renderSection);
    }
  }

  function initializeAll() {
    initializeSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });
})();
